import { createRouter, createWebHashHistory, RouteRecordRaw, createWebHistory } from 'vue-router';
import { staticRoutes } from './staticRoutes';
import defaultRoutes from './defaultRoutes';

const routes: any = defaultRoutes.concat(staticRoutes);

const router = createRouter({
  history: createWebHistory(),
  routes,
});
router.beforeEach((to, from, next) => {

  let userInfo = localStorage.getItem('user');
  let title: any = to.meta.title;
  console.log(1111111111111, to);
  if (title) {
    //判断是否有标题
    document.title = title;
    next();
  } else {
    if (userInfo) {
      next();
    } else {
      next(
        //   {
        //   path: '/login'
        // }
      );
    }
  }
  window.scrollTo(0, 0);
});
export default router;
